module.exports = __webpack_public_path__ + "img/HEATER_AMENITY.9cc23664.svg";